var React = require('react');

function LinkedinCircle (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,[React.createElement("path",{"d":"M31.73,63.06A31.53,31.53,0,1,1,63.46,31.53,31.67,31.67,0,0,1,31.73,63.06ZM31.73,2A29.53,29.53,0,1,0,61.46,31.53,29.67,29.67,0,0,0,31.73,2Z","key":0}),React.createElement("path",{"d":"M20.46,21.37a3.06,3.06,0,0,1,0-4.39,3.11,3.11,0,0,1,4.42,0,3.08,3.08,0,0,1,0,4.39,3.11,3.11,0,0,1-4.42,0Zm-.52,20.54V24.66h5.4V41.91Zm20.21,0V33.49a9,9,0,0,0-.35-3,2.44,2.44,0,0,0-2.49-1.56,2.73,2.73,0,0,0-2.62,1.38,6.36,6.36,0,0,0-.58,3.06v8.54H28.77V24.66h5.17V27H34a4.64,4.64,0,0,1,1.86-1.9,5.74,5.74,0,0,1,3.26-.92c2.51,0,4.27.78,5.28,2.36a11.55,11.55,0,0,1,1.16,5.89v9.46Z","key":1})])));
}

LinkedinCircle.defaultProps = {"viewBox":"0 0 63.46 63.06"};

module.exports = LinkedinCircle;

LinkedinCircle.default = LinkedinCircle;
